<template>
    <div class="xwzx_container">
        <!-- 栏目分类 -->
        <div class="xwzx_tabs">
            <div
                class="xwzx_tab"
                v-for="item in gyssInfo"
                :key="item.typeId"
                :class="{ active: tabTypeId === item.typeId }"
                @click="changeTab(item.typeId)">
                {{ item.typeName }}
            </div>
        </div>

        <div class="xwzx_content">
            <!-- 大图头条（复用轮播数据，深绿渐变压白字） -->
            <div class="xwzx_hero reveal-init" v-if="carousel.length > 0" v-reveal>
                <el-carousel arrow="never" height="100%" indicator-position="none" :interval="4500">
                    <el-carousel-item v-for="item in carousel" :key="item.articleid">
                        <div class="xwzx_hero_media">
                            <el-image :src="item.articlecarouselimg" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                            <div class="xwzx_hero_overlay">
                                <span class="xwzx_hero_tag">头条</span>
                                <div class="xwzx_hero_title">{{ item.articletitle }}</div>
                                <div class="xwzx_hero_date">{{ item.articledate }}</div>
                                <div class="xwzx_hero_excerpt" v-html="item.articletext"></div>
                                <el-button
                                    class="xwzx_hero_btn"
                                    plain
                                    size="small"
                                    @click="showArticleDeltail(item)">查看详情 →</el-button>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>

            <!-- 紧凑列表 -->
            <div class="xwzx_list" v-if="article.length > 0">
                <div
                    class="xwzx_item reveal-init"
                    v-for="(item, idx) in article"
                    :key="item.articleid"
                    v-reveal="idx * 70">
                    <div class="xwzx_item_thumb" @click="showArticleDeltail(item)">
                        <el-image :src="item.articlefaceimg" fit="cover">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </div>
                    <div class="xwzx_item_body">
                        <div class="xwzx_item_title" @click="showArticleDeltail(item)">{{ item.articletitle }}</div>
                        <div class="xwzx_item_meta">
                            <span class="xwzx_item_date">{{ item.articledate }}</span>
                            <el-button type="text" class="xwzx_item_more" @click="showArticleDeltail(item)">查看详情 →</el-button>
                        </div>
                        <div class="xwzx_item_excerpt" v-html="item.articletext"></div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="xwzx_pager">
                    <el-pagination
                        layout="prev, pager, next"
                        @current-change="pageChanged"
                        :current-page="pageInfo.currentPage"
                        :total="pageInfo.totals"
                        :page-size="pageInfo.pageSize">
                    </el-pagination>
                </div>
            </div>

            <!-- 空态 -->
            <div class="xwzx_empty" v-if="carousel.length === 0 && article.length === 0">
                暂无内容
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      tabTypeId: 1,
      gyssInfo: [
        { typeName: '企业新闻', typeId: 1 },
        { typeName: '业内资讯', typeId: 2 },
        { typeName: '相关法规', typeId: 3 }
      ],
      carousel: [],
      article: [],
      pageInfo: {
        currentPage: 1,
        totals: 50,
        pageSize: 3
      }
    }
  },
  methods: {
    // 获取轮播
    queryCarouselByType (typeId) {
      this.$http.post('/admin/queryCarouselByType/' + typeId).then(res => {
        this.carousel = res.data.data
      })
    },
    // 根据类型获取文章
    getArticleByPage (typeId) {
      this.$http.post('/admin/getArticleByType/' + typeId, this.pageInfo).then(res => {
        this.pageInfo.totals = res.data.totals
        this.article = res.data.articles
      })
    },
    changeTab (typeId) {
      typeId = Number(typeId)
      this.pageInfo = {
        currentPage: 1,
        totals: 0,
        pageSize: 3
      }
      window.sessionStorage.setItem('tabTypeId', typeId)
      this.tabTypeId = typeId
      if (typeId === 1) {
        this.queryCarouselByType(3)
        this.getArticleByPage(2)
      } else if (typeId === 2) {
        this.queryCarouselByType(4)
        this.getArticleByPage(3)
      } else if (typeId === 3) {
        // 相关法规无头条轮播，清空残留
        this.carousel = []
        this.getArticleByPage(4)
      }
    },
    pageChanged (currentPage) {
      this.pageInfo.currentPage = currentPage
      this.getArticleByPage(this.tabTypeId + 1)
    },
    showArticleDeltail (data) {
      window.sessionStorage.setItem('articleDetail', JSON.stringify(data))
      window.sessionStorage.setItem('activeIndex', '/xwzx')
      this.$router.push('articleDetail')
    }
  },
  directives: {
    // 进场动画指令：内容默认可见，动画仅作「进场增强」。
    // 进入视口或已处于视口内时加 reveal-in 播放渐显；即使回调未触发，内容也始终可见，不会被藏死。
    reveal: {
      inserted (el, binding) {
        const delay = binding.value || 0
        el.style.setProperty('--reveal-delay', delay + 'ms')
        const vh = window.innerHeight || document.documentElement.clientHeight
        const rect = el.getBoundingClientRect()
        if (rect.top < vh && rect.bottom > 0) {
          // 已在视口内：下一帧同步揭示，避免闪烁
          requestAnimationFrame(() => el.classList.add('reveal-in'))
        } else {
          // 离屏：滚动到位时揭示
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add('reveal-in')
                io.unobserve(el)
              }
            })
          }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' })
          io.observe(el)
        }
      }
    }
  },
  mounted () {
    this.changeTab(this.tabTypeId)
  }
}
</script>

<style lang="less" scoped>
.xwzx_container {
    --ss-green-800: #163a2b;
    --ss-green: #2e6b4f;
    --ss-green-200: #e3ece5;
    --ss-sand: #f7f5f0;
    --ss-gold: #c9a86a;

    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 0 0 16px;
    overflow: hidden;
}

/* 栏目分类胶囊 */
.xwzx_tabs {
    display: flex;
    gap: 10px;
    padding: 18px 24px;
    border-bottom: 1px solid #ece8df;
}
.xwzx_tab {
    padding: 8px 22px;
    border-radius: 999px;
    font-size: 15px;
    color: #5b6b62;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background .3s ease, color .3s ease, box-shadow .3s ease;
}
.xwzx_tab:hover {
    color: var(--ss-green);
    background: #eef3f0;
}
.xwzx_tab.active {
    background: var(--ss-green);
    color: #fff;
    box-shadow: 0 4px 12px rgba(22, 58, 43, .18);
}

.xwzx_content {
    padding: 24px;
}

/* 进场动画（默认可见 + 渐显，防呆不隐藏） */
.reveal-init { }
.reveal-init.reveal-in {
    animation: xwzxReveal .7s cubic-bezier(.22, .61, .36, 1) both;
    animation-delay: var(--reveal-delay, 0ms);
}
@keyframes xwzxReveal {
    from { opacity: 0; transform: translateY(26px); }
    to   { opacity: 1; transform: none; }
}

/* 大图头条 */
.xwzx_hero {
    width: 100%;
    height: 380px;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    margin-bottom: 28px;
    box-shadow: 0 10px 30px rgba(22, 58, 43, .12);
}
.xwzx_hero ::v-deep .el-carousel,
.xwzx_hero ::v-deep .el-carousel__container {
    height: 100%;
}
.xwzx_hero_media {
    position: relative;
    width: 100%;
    height: 100%;
}
.xwzx_hero_media ::v-deep .el-image {
    width: 100%;
    height: 100%;
}
.xwzx_hero_media ::v-deep .el-image__inner {
    transition: transform .8s cubic-bezier(.22, .61, .36, 1);
}
.xwzx_hero:hover .xwzx_hero_media ::v-deep .el-image__inner {
    transform: scale(1.05);
}
.xwzx_hero_overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 34px 38px;
    background: linear-gradient(180deg, rgba(22, 58, 43, 0) 28%, rgba(22, 58, 43, .85) 100%);
    color: #fff;
}
.xwzx_hero_tag {
    align-self: flex-start;
    background: var(--ss-gold);
    color: var(--ss-green-800);
    font-size: 12px;
    letter-spacing: 2px;
    padding: 3px 12px;
    border-radius: 999px;
    margin-bottom: 12px;
}
.xwzx_hero_title {
    font-size: 30px;
    font-weight: 600;
    line-height: 1.3;
    max-width: 82%;
}
.xwzx_hero_date {
    font-size: 14px;
    opacity: .85;
    margin: 8px 0;
}
.xwzx_hero_excerpt {
    font-size: 15px;
    line-height: 1.7;
    opacity: .9;
    max-width: 72%;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.xwzx_hero_btn {
    align-self: flex-start;
    margin-top: 14px;
    color: #fff;
    border-color: rgba(255, 255, 255, .6);
}
.xwzx_hero_btn:hover {
    background: rgba(255, 255, 255, .14);
    border-color: #fff;
}

/* 紧凑列表 */
.xwzx_list {
    width: 100%;
}
.xwzx_item {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    padding: 22px 8px;
    border-bottom: 1px solid #ece8df;
    transition: background .3s ease;
}
.xwzx_item:hover {
    background: linear-gradient(90deg, rgba(46, 107, 79, .05), rgba(46, 107, 79, 0));
}
.xwzx_item_thumb {
    flex: 0 0 200px;
    width: 200px;
    height: 132px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
}
.xwzx_item_thumb ::v-deep .el-image {
    width: 100%;
    height: 100%;
}
.xwzx_item_thumb ::v-deep .el-image__inner {
    transition: transform .6s cubic-bezier(.22, .61, .36, 1);
}
.xwzx_item:hover .xwzx_item_thumb ::v-deep .el-image__inner {
    transform: scale(1.06);
}
.xwzx_item_body {
    flex: 1;
    min-width: 0;
}
.xwzx_item_title {
    font-size: 20px;
    font-weight: 600;
    color: var(--ss-green-800);
    line-height: 1.45;
    position: relative;
    display: inline-block;
    cursor: pointer;
    transition: color .3s ease;
}
.xwzx_item_title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 2px;
    background: var(--ss-gold);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform .4s ease;
}
.xwzx_item:hover .xwzx_item_title {
    color: var(--ss-gold);
}
.xwzx_item:hover .xwzx_item_title::after {
    transform: scaleX(1);
}
.xwzx_item_meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
}
.xwzx_item_date {
    color: var(--ss-gold);
    font-size: 14px;
}
.xwzx_item_more {
    color: var(--ss-green) !important;
    font-size: 14px;
    padding: 0 !important;
}
.xwzx_item_excerpt {
    color: #56635b;
    font-size: 15px;
    line-height: 1.7;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.xwzx_pager {
    display: flex;
    justify-content: center;
    padding: 30px 0 6px;
}
.xwzx_empty {
    padding: 70px 0;
    text-align: center;
    color: #9aa39c;
    font-size: 15px;
}

@media screen and (max-width: 768px) {
    .xwzx_content { padding: 16px; }
    .xwzx_hero { height: 260px; margin-bottom: 18px; }
    .xwzx_hero_overlay { padding: 20px; }
    .xwzx_hero_title { font-size: 22px; max-width: 100%; }
    .xwzx_hero_excerpt { max-width: 100%; -webkit-line-clamp: 2; }
    .xwzx_item { flex-direction: column; gap: 12px; padding: 18px 4px; }
    .xwzx_item_thumb { width: 100%; flex: none; height: 180px; }
}
</style>
